import React, { memo } from "react";

import { SECTION_IDS } from '../../constants/routes';

const IconTable = () => (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="2" y="5" width="20" height="14" rx="2"/>
        <line x1="12" y1="5" x2="12" y2="19"/>
        <circle cx="7" cy="11" r="1.4" fill="currentColor" stroke="none"/>
        <circle cx="17" cy="13" r="1.4" fill="currentColor" stroke="none"/>
    </svg>
);

const IconTarget = () => (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10"/>
        <circle cx="12" cy="12" r="6"/>
        <circle cx="12" cy="12" r="2"/>
    </svg>
);

const IconTrophy = () => (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M6 3h12l-1.5 9A4.5 4.5 0 0112 16.5a4.5 4.5 0 01-4.5-4.5L6 3z"/>
        <path d="M6 3H3l.5 4A3.5 3.5 0 006 9.5M18 3h3l-.5 4A3.5 3.5 0 0118 9.5"/>
        <line x1="12" y1="16.5" x2="12" y2="21"/>
        <line x1="8" y1="21" x2="16" y2="21"/>
    </svg>
);

const IconCommunity = () => (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="9" cy="7" r="4"/>
        <path d="M2 21v-2a5 5 0 015-5h4a5 5 0 015 5v2"/>
        <path d="M16 3.13a4 4 0 010 7.75"/>
        <path d="M21 21v-2a4 4 0 00-3-3.87"/>
    </svg>
);

const FEATURES = [
    {
        Icon: IconTable,
        title: 'Tische',
        text: 'In unserem Vereinsheim stehen mehrere Profi-Kicker zur Verfügung – zum Trainieren, Entspannen und für spannende Matches jederzeit.',
    },
    {
        Icon: IconTarget,
        title: 'Training',
        text: 'Wir bieten gezielte Trainingsmöglichkeiten für alle Levels. Unser erfahrenes Team hilft dir, Technik und Taktik auf das nächste Level zu bringen.',
    },
    {
        Icon: IconTrophy,
        title: 'Turniere',
        text: 'Regelmäßige Turniere für alle Spielniveaus – von lockeren Spaßturnieren bis hin zu hochkarätigen Wettkämpfen. Für jeden ist etwas dabei.',
    },
    {
        Icon: IconCommunity,
        title: 'Community',
        text: 'Das KickerEck ist mehr als ein Verein. Es ist ein Treffpunkt, an dem neue Freundschaften entstehen und jeder willkommen ist.',
    },
];

export const About = memo(() => {
    return (
        <div id={SECTION_IDS.ABOUT} className="text-center">
            <div className="container">
                <div className="section-title">
                    <h2>Über uns</h2>
                    <p>
                        Willkommen im KickerEck! Egal ob leidenschaftlicher Tischfußballer oder
                        Neueinsteiger – bei uns findest du den perfekten Ort, um deine Fähigkeiten zu
                        verbessern, neue Freunde zu treffen und jede Menge Spaß zu haben.
                    </p>
                </div>

                <div className="about-image-wrap">
                    <img
                        src="img/about.jpg"
                        alt="KickerEck Turnier – Spieler an mehreren Tischen"
                        className="about-full-image"
                        loading="lazy"
                    />
                </div>

                <div className="row about-features">
                    {FEATURES.map(({ Icon, title, text }) => (
                        <div key={title} className="col-sm-6 col-md-3 about-feature-col">
                            <div className="about-feature">
                                <span className="about-feature-icon">
                                    <Icon />
                                </span>
                                <h4>{title}</h4>
                                <p>{text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
});

About.displayName = 'About';
